import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { csRegister } from "../../api/auth.api";
import { csSession } from "../../auth/session";
import styles from "../../styles/login.module.css";

export default function Register() {

  const nav = useNavigate();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    password: "",
  });
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const onChange = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e?.preventDefault?.();
    if (loading) return;

    setMsg("");

    // sadə validation
    if (!form.firstName.trim()) return setMsg("Ad daxil edin.");
    if (!form.lastName.trim()) return setMsg("Soyad daxil edin.");
    if (!form.phone.trim()) return setMsg("Telefon nömrəsini daxil edin.");
    if (!form.password.trim()) return setMsg("Şifrə daxil edin.");
    if (form.password.length < 6)
      return setMsg("Şifrə minimum 6 simvol olmalıdır.");

    try {
      setLoading(true);
      const ref = localStorage.getItem("cs_ref_code") || "";
      const payloadForm = { ...form, referralCode: ref }; // ✅ yeni
      const res = await csRegister(payloadForm);

      // uğurlu olduqda istersən sil:
      localStorage.removeItem("cs_ref_code");

      // backend response fallback
      const payload = res?.data?.data ?? res?.data ?? res;

      csSession.setUser(payload);
      nav("/couriersub/verify");
    } catch (err) {
      const apiMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Qeydiyyat alınmadı. Yenidən cəhd edin.";
      setMsg(apiMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.brand}>MotoTaksi.az</div>
          <h1 className={styles.title}>Kuryer Abunəliyi</h1>
          <p className={styles.subtitle}>Qeydiyyat formu</p>
        </div>

        <form className={styles.form} onSubmit={submit}>
          <label className={styles.label}>Ad</label>
          <input
            className={styles.input}
            placeholder="Adınız"
            value={form.firstName}
            onChange={(e) => onChange("firstName", e.target.value)}
            autoComplete="given-name"
          />

          <label className={styles.label}>Soyad</label>
          <input
            className={styles.input}
            placeholder="Soyadınız"
            value={form.lastName}
            onChange={(e) => onChange("lastName", e.target.value)}
            autoComplete="family-name"
          />

          <label className={styles.label}>Telefon</label>
          <input
            className={styles.input}
            placeholder="0551234567"
            value={form.phone}
            onChange={(e) => onChange("phone", e.target.value)}
            inputMode="tel"
            autoComplete="username"
          />

          <label className={styles.label}>Şifrə</label>
          <input
            className={styles.input}
            placeholder="Minimum 6 simvol"
            type="password"
            value={form.password}
            onChange={(e) => onChange("password", e.target.value)}
            autoComplete="new-password"
          />

          <button className={styles.btn} type="submit" disabled={loading}>
            {loading ? "Göndərilir..." : "Qeydiyyat"}
          </button>

          {msg && <div className={styles.error}>{msg}</div>}

          <div className={styles.footer}>
            Artıq hesabınız var?{" "}
            <Link className={styles.link} to="/couriersub/login">
              Giriş
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

